<template>
  <div class="revenue-warning">
    <!-- 页面标题 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据预警</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 预警信息 - 2列布局，默认显示10条 -->
    <el-alert
      v-if="warnings.length > 0"
      title="营业额预警"
      type="warning"
      :closable="false"
      style="margin: 20px 0"
    >
      <el-row :gutter="20" style="display: flex; flex-wrap: wrap;">
        <el-col 
          :span="12" 
          v-for="(warning, index) in displayedWarnings" 
          :key="index" 
          style="margin-bottom: 10px; display: flex;"
        >
          <div style="padding: 10px; background: #FEF0F0; border-radius: 4px; width: 100%;">
            <i class="el-icon-warning" style="color: #F56C6C; font-size: 16px;"></i>
            <strong style="font-size: 15px;">{{ warning.storeName }}</strong><br/>
            <span style="font-size: 14px;">
              本周 ¥{{ warning.currentWeek }} → 上周 ¥{{ warning.lastWeek }}
              <span style="color: #F56C6C; font-weight: bold; margin-left: 5px; font-size: 15px;">↓{{ warning.dropRate }}%</span>
            </span>
          </div>
        </el-col>
      </el-row>
      
      <!-- 更多按钮 -->
      <div v-if="warnings.length > 10" style="text-align: center; margin-top: 10px;">
        <el-button 
          type="text" 
          @click="showAllWarnings = !showAllWarnings"
          style="font-size: 14px;"
        >
          <i :class="showAllWarnings ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          {{ showAllWarnings ? '收起' : `查看更多 (${warnings.length - 10}条)` }}
        </el-button>
      </div>
    </el-alert>

    <!-- 无预警提示 -->
    <el-card v-else style="margin: 20px 0; text-align: center; padding: 40px;">
      <i class="el-icon-success" style="font-size: 48px; color: #67C23A;"></i>
      <p style="font-size: 18px; margin-top: 20px; color: #67C23A;">暂无营业额预警</p>
      <p style="color: #909399;">所有店铺营业额正常</p>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'RevenueWarning',
  data() {
    return {
      warnings: [],
      showAllWarnings: false
    }
  },
  computed: {
    // 显示的预警列表（按下降率排序，默认显示前10条）
    displayedWarnings() {
      const sortedWarnings = [...this.warnings].sort((a, b) => {
        return parseFloat(b.dropRate) - parseFloat(a.dropRate)
      })
      
      if (this.showAllWarnings || sortedWarnings.length <= 10) {
        return sortedWarnings
      }
      return sortedWarnings.slice(0, 10)
    }
  },
  created() {
    this.loadWarnings()
  },
  methods: {
    // 加载预警数据
    async loadWarnings() {
      try {
        const { data: res } = await this.$http.post('/statistics/revenue/', {
          startDate: this.getDateString(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)),
          endDate: this.getDateString(new Date()),
          storeIds: [],
          dimension: 'day'
        })
        
        if (res.status === 0) {
          this.warnings = res.warnings || []
        } else {
          this.$message.warning('加载预警数据失败')
        }
      } catch (error) {
        console.error('加载预警数据失败:', error)
        // 如果是401错误，不显示错误提示，避免重复跳转
        if (error.response && error.response.status === 401) {
          console.log('未授权访问，请登录')
        } else {
          this.$message.warning('加载预警数据失败，请稍后重试')
        }
      }
    },
    
    // 格式化日期
    getDateString(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
.revenue-warning {
  padding: 20px;
}
</style>
